<template>
  <PgSpan
    class="pg-click-to-router-by-biz"
    :class="{ 'pg-click-to-router-by-biz__pointer': !!value }"
    @click="toRouter"
    >{{ value ?? '-' }}</PgSpan
  >
</template>
<script setup>
import { getCurrentInstance, inject } from 'vue'
import { get } from '../../../utils/index'
import { pgMessage } from '../../message/index'
import PgSpan from './span-main.vue'

import { ROUTERJUMPUNMOUNTCOMPONENT } from '../../../tokens/index'

const props = defineProps({
  value: [Array, String, Number],
  // 支持调用后台接口getOrderRoute获取跳转路由name
  getAllBizUrl: {
    type: String,
    default: '~static/mock/orderTypeRouter.json',
  },
  getAllBizParams: Object,
  bizCode: String,
  routerQuery: Object,
  routerName: String,
})

const { proxy } = getCurrentInstance()

const { closeDrawer } = inject(ROUTERJUMPUNMOUNTCOMPONENT, {})
const toRouter = async () => {
  if (props.value && props.routerName) {
    const router = proxy.$router || window.$vueApp?.$router
    if (closeDrawer) closeDrawer()
    router.push({ name: props.routerName, query: props.routerQuery })
  } else if (props.value) {
    const [resData] = await get(props.getAllBizUrl, { ...props.getAllBizParams })
    const allBiz = resData?.data ?? {}
    const routerName = allBiz?.name || allBiz[props.bizCode]?.name
    if (routerName) {
      const router = proxy.$router || window.$vueApp?.$router
      if (closeDrawer) closeDrawer()
      router.push({ name: routerName, query: props.routerQuery })
    } else {
      pgMessage.error('未配置该单据路由')
    }
  }
}
</script>

<style lang="scss">
@import '../style/click-to-router-by-biz.scss';
</style>
